import * as React from 'react';
import { ROOT_PATH } from '../constants/routes';
import { get, startsWith } from 'lodash';

const NotFound = ({ location }) => (
    <div className="ckp-errors">
        {startsWith(get(location, 'pathname'), '/https://') ? (
            (window.location = get(location, 'pathname').replace('/https', 'https'))
        ) : (
            <React.Fragment>
                <h1 className="ckp-errors-title">404 - Not found</h1>
                <h2 className="ckp-errors-subtitle">
                    Return to <a href={ROOT_PATH}>Home</a>.
                </h2>
                <h2 className="ckp-errors-subtitle">
                    Please contact <a href="mailto:techsupport@clearem.tv">Clear'em support</a>, if you think this is an
                    error.
                </h2>
            </React.Fragment>
        )}
    </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js